import React, { useState } from 'react';

import DevConnection from '../../components/DevConnection';
import SearchBar from '../../components/SearchBar';

import './Dashboard.scss';

function Dashboard() {
  const [query, setQuery] = useState('');
  const [search, setSearch] = useState([]);

  return (
    <div className="container full-height-grow">
      <section id="dashboard" className="">
        <SearchBar query={query} setQuery={setQuery} setSearch={setSearch} />
        <DevConnection search={search} />
      </section>
      <div className="home-page-circle-1" />
      <div className="home-page-circle-2" />
      <div className="home-page-circle-3" />
    </div>
  );
}

export default Dashboard;
